
export function getStreamPublishParameters(liveProfile, streamName, password, useTranscoder) {
    const result = {
        url: '',
        name: '',
    };

    if (!liveProfile?.publishServer) {
        return result;
    }

    result.url = `rtmp://${liveProfile.publishServer.publishHost}/`;
    result.name = streamName;

    if (liveProfile.publishServer.type === 'flussonic') {
        result.url += `static`;
        result.name += `_${password}`;
    } else if (useTranscoder) {
        result.url += `transcoder?${password}`;
    } else {
        result.url += `octopus4?${password}`;
        result.name += '_%i';
    }

    return result;
}
